const obj_sort_by_val = (o, f) => {

	let n = {}

	Object.keys(o).sort( (k1, k2) => f(o[k1], o[k2]) ).map( k => n[k] = o[k] )

	return n
}

export default obj_sort_by_val